import type React from 'react';
import classNames from 'classnames';

import Icons from 'assets/icons';

interface FreeformOptionProps {
  value: string;
  isActive: boolean;
  onChange: (value: string) => void;
}

const FreeformOption = ({
  value,
  isActive,
  onChange,
}: FreeformOptionProps): React.JSX.Element => (
  <label
    className={classNames(
      'w-full flex items-center px-3.5 py-2.5 rounded-md cursor-text gap-3 transition-colors duration-100',
      isActive
        ? 'bg-navy-50 border-2 border-navy-600'
        : 'bg-white border border-gray-200 hover:bg-navy-50 hover:border-navy-300 focus-within:border-navy-700'
    )}
  >
    <span aria-hidden="true" className="text-gray-400 flex flex-shrink-0">
      <Icons.EditPencil customClass="size-3.5" />
    </span>
    <input
      type="text"
      aria-label="Something else — type your own answer"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder="Something else — type your own answer"
      className="flex-1 border-none bg-transparent text-sm text-gray-700 outline-none placeholder:text-gray-400 placeholder:italic"
    />
  </label>
);

export default FreeformOption;
